import { Svg } from 'client/widget-components/basicComponents';
import React from 'react';

interface FileIconProps extends React.ComponentProps<typeof Svg> {
    size?: number;
}

const FileIcon = ({ size = 40, ...restProps }: FileIconProps) => {
    return (
        <Svg
            width={size}
            height={size}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.69462 0H24L36 12V34.7926C36 37.6711 33.5088 40 30.4403 40H9.57031C6.49114 40 4 37.6711 4 34.7926V5.20733C3.99995 2.32878 6.61539 0 9.69462 0Z"
                fill="#F4F4F5"
            />
            <path
                d="M11 28H20.7143M11 32H28"
                stroke="#D4D4D8"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.0257 8.16V0L36 12H28.0171C24.4248 12 23.8593 9.44 24.0257 8.16Z"
                fill="#D4D4D8"
            />
        </Svg>
    );
};

export default FileIcon;

